<div class="container single-view" id="add-digital-cards">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr"></div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-digital-card-title" class="section-title">{{ 'DIGITAL_CARD_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-digital-card-subtitle" class="section-subtitle mt-1 text-base">{{ 'DIGITAL_CARD_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form [formGroup]="digitalCardFormGroup" class="row">
              <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0 overflow-visible">
                <div class="row">
                  <div class="field-wr flex flex-col col-12 mt-2">
                    <section class="row">
                      <div class="col-12">
                        <h3 class="border-b pb-3 mt-0">{{ 'DIGITAL_CARDS.SEARCH' | translate }}</h3>
                      </div>
                      <label data-testid="add-digital-card-field-serialnumber" class="block text-sm mb-2">
                        {{ 'DIGITAL_CARDS.SERIAL_NUMBER' | translate }} <i class="icon-required-field"></i>
                      </label>
                      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
                        <div class="flex items-stretch camera-btn-field-wr">
                          <input data-testid="search" type="text" id="search-sn" formControlName="serialNumber" autocomplete="off" disallowSpaces>
                          <textbox-camera data-testid="search-camera" class="shrink-0 self-stretch flex items-center"
                          (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
                        </div>
                      </div>
                      <div class="field-wr flex flex-col col-12 col-md-3">
                        <button data-testid="search-validate-btn" class="btn primary-btn" [disabled]="digitalCardFormGroup.invalid"
                          (click)="searchSerialNumber()">
                          {{ 'WARRANTY_ACTIVATION.BTN_VALIDATE_SERIAL_NUMBER' | translate }}
                        </button>
                      </div>
                    </section>
                    @if (hasSubmittedSerialNumberSearch) {
                      <section class="row pb-4">
                        <div class="col-12">
                          <h3 data-testid="add-digitalcard-serialnumber-results" class="border-t pt-3">{{ 'DIGITAL_CARDS.RESULTS' | translate }}</h3>
                        </div>
                        <!-- Product results -->
                        @if (!isResultsEmpty) {
                          <ul id="product-results">
                            @for (item of itemsList; track item) {
                              <div class="product-item row mb-3">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                                  <img data-testid="digital-card-product-image" src="{{ item.productCustomisation?.imageUrl || item.product?.imageUrl || item.product?.productType?.imageUrl }}"
                                    class="w-100 mt-2 featured-image">
                                </div>
                                <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                                  <dl class="details-grid mt-3">
                                    <dt data-testid="digital-card-product-label" class="label grid-cols-1">{{ 'DIGITAL_CARDS.PRODUCT_NAME' | translate }}</dt>
                                    <dd data-testid="digital-card-product" class="value pb-3">{{ item.product!.name }}</dd>
                                    <dt data-testid="digital-card-sku-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.SKU' | translate }}</dt>
                                    <dd data-testid="digital-card-sku" class="value pt-3 pb-3">{{ item.product!.sku | defaultValue }}</dd>
                                    <dt data-testid="digital-card-collection-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.COLLECTION' | translate }}</dt>
                                    <dd data-testid="digital-card-collection" class="value pt-3 pb-3">{{ getCollectionNames(item) | defaultValue }}</dd>
                                    <dt data-testid="digital-card-category-label" class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.CATEGORY' | translate }}</dt>
                                    <dd data-testid="digital-card-category" class="value pt-3 pb-3">{{ getCategoryNames(item) | defaultValue }}</dd>
                                  </dl>
                                  <dl>
                                    <div class="row mt-3">
                                      <div class="col-4">
                                        <button data-testid="add-digital-card-btn" class="btn outline-btn w-full" (click)="createDigitalCard(item.id!)">
                                          {{ 'DIGITAL_CARDS.BTN_CREATE_DIGITAL_CARD' | translate }}</button>
                                      </div>
                                    </div>
                                  </dl>
                                </div>
                              </div>
                            }
                          </ul>
                        } @else {
                          <div class="text-center">
                            <p class="mb-2">{{'DIGITAL_CARDS.SERIAL_NUMBER_NOT_SOLD_NO_RESULTS' | translate}}</p>
                            <button data-testid="add-digital-card-create-digital-card-btn" id="btn-create-serial-number" class="btn outline-btn"
                                (click)="onOpenCreateSerialNumberModalbox()">{{ 'DIGITAL_CARDS.BTN_CREATE' | translate }}
                            </button>
                          </div>
                        }
                      </section>
                    }
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modalbox: Create Serial Number -->
<p-dialog [(visible)]="showCreateSerialNumberModal" [header]="'DIGITAL_CARDS.MODALBOX_TITLE_CREATE' | translate" [modal]="true" [draggable]="false" [resizable]="false" [blockScroll]="true">
  <form [formGroup]="createSerialNumberForm">
    <div class="row">
      <div class="field-wr col-12" [ngClass]="companyIsPrepaired ? 'col-md-4' : 'col-md-6'">
        <label data-testid="create-item-field-serialnumber">{{ 'DIGITAL_CARDS.SERIAL_NUMBER' | translate }}</label>
        <input data-testid="create-item-serialnumber-input" type="text" formControlName="serialNumber" autocomplete="off">
      </div>
      <div class="field-wr col-12" [ngClass]="companyIsPrepaired ? 'col-md-4' : 'col-md-6'">
        <label data-testid="create-item-field-product" class="mb-2">
          {{ 'DIGITAL_CARDS.PRODUCT_NAME' | translate }}
          <i class="icon-required-field"></i>
        </label>
        <app-custom-dropdown
          data-testid="product"
          [placeholder]="'ITEM_CREATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="comboData.rowsPerPageOption || 5"
          [totalCount]="comboData.totalRecords"
          [totalPages]="getComboTotalPages()"
          [options]="comboData.list"
          formControlName="productId"
          (onLazyLoad)="onLazyLoadComboData($event)">
        </app-custom-dropdown>
        @if (createSerialNumberForm.get('productId')?.invalid && createSerialNumberForm.get('productId')?.touched) {
          <small data-testid="product-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
        }
      </div>

      @if (companyIsPrepaired) {
        <div class="field-wr col-12 col-md-4">
          <label data-testid="create-item-field-warrantycode" class="mb-2" for="warrantyCode">
            {{ 'ITEM_CREATE.PREPAIRED_CODE' | translate }}
            <i class="icon-required-field"></i>
          </label>
          <input data-testid="create-item-warrantycode-input" type="text" formControlName="warrantyCode" autocomplete="off">
          @if (createSerialNumberForm.get('warrantyCode')?.invalid && createSerialNumberForm.get('warrantyCode')?.touched) {
            <small data-testid="warrantycode-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
          }
        </div>
      }
    </div>

    <div class="row mt-1" id="product-preview">
      <hr role="presentation" class="w-full mb-2 border-t">
      <div class="col-12">
        @if (product.id) {
          <div class="row mt-4 mb-2">
            <div class="col-12">
              <h4 data-testid="create-item-summary">{{ 'DIGITAL_CARDS.PRODUCT_SUMMARY' | translate }}</h4>
            </div>
          </div>
          <div class="product-item row">
            <div class="col-12 col-md-4">
              <img data-testid="create-item-product-image" [src]="product.imageUrl" class="w-100 mt-2 featured-image">
            </div>
            <div class="col-12 col-md-8">
              <dl class="details-grid mt-3">
                <dt data-testid="create-item-product-label"  class="label grid-cols-1">{{ 'DIGITAL_CARDS.PRODUCT_NAME' | translate }}</dt>
                <dd data-testid="create-item-product"  class="value pb-3">{{ product.name }}</dd>
                <dt data-testid="create-item-sku-label"  class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.SKU' | translate }}</dt>
                <dd data-testid="create-item-sku"  class="value pt-3 pb-3">{{ product.sku }}</dd>
                <dt data-testid="create-item-category-label"  class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.CATEGORY' | translate }}</dt>
                <dd data-testid="create-item-category"  class="value pt-3 pb-3">{{ product.productType?.name }}</dd>
                <dt data-testid="create-item-description-label"  class="label grid-cols-1 pt-3">{{ 'DIGITAL_CARDS.DESCRIPTION' | translate }}</dt>
                <dd data-testid="create-item-description"  class="value pt-3 pb-3">{{ product.description }}</dd>
              </dl>
            </div>
          </div>
        } @else {
          <div class="notice text-sm px-4 py-4 mt-3">
            <p data-testid="create-item-preview-hint" >{{ 'DIGITAL_CARDS.SELECT_PRODUCT_PREVIEW_HINT' | translate }}</p>
          </div>
        }
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button data-testid="create-item-cancel-btn"  class="btn outline-btn" (click)="onCancelCreateSerialNumber()">
      {{ 'DIGITAL_CARDS.BTN_CANCEL' | translate }}
    </button>
    <button data-testid="create-item-create-btn" class="btn primary-btn" (click)="onCreateSerialNumber()" [disabled]="createSerialNumberForm.invalid">
      {{ 'DIGITAL_CARDS.BTN_CREATE' | translate }}
    </button>
  </ng-template>
</p-dialog>
